import type { VerificationRequest } from 'matrix-js-sdk/src/crypto-api';
import { VerificationPhase } from 'matrix-js-sdk/src/crypto-api';
import { useEffect } from 'react';

import { CrossSigningStatusEnum } from 'contexts/MatrixDeviceContext/types';
import logger from 'utils/logging/faro';

import { VerificationErrorEnum } from '../../utils';

const VERIFICATION_METHOD = 'm.sas.v1';

type UseSasAutoStartParams = {
  crossSigningStatus: CrossSigningStatusEnum;
  activeRequest: VerificationRequest | null;
  hasChosenSasVerification: boolean;
  setErrorKey: (value: VerificationErrorEnum | null) => void;
};

const useSasAutoStart = ({
  crossSigningStatus,
  activeRequest,
  setErrorKey,
  hasChosenSasVerification,
}: UseSasAutoStartParams) => {
  useEffect(() => {
    if (
      crossSigningStatus === CrossSigningStatusEnum.VERIFIED ||
      !activeRequest ||
      !activeRequest.initiatedByMe ||
      activeRequest.phase !== VerificationPhase.Ready ||
      !hasChosenSasVerification
    ) {
      return;
    }

    activeRequest.startVerification(VERIFICATION_METHOD).catch((e) => {
      logger.error('Failed to start SAS verification', e);
      setErrorKey(VerificationErrorEnum.FAILED_RETRY);
    });
  }, [activeRequest, crossSigningStatus, setErrorKey, hasChosenSasVerification]);
};

export default useSasAutoStart;
